import * as types from './actiontypes';

export function setIsCurrentResourceAvailable(isAvailable) {
	return {
		type: types.SET_IS_CURRENT_RESOURCE_AVAILABLE,
		isCurrentResourceAvailable: isAvailable
	};
}